import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Customers } from '../../../pages/Customers'

const customersListSearchSchema = z.object({
  search: z.string().optional(),
  organizationIds: z.array(z.string()).optional().catch([]),
  sortBy: z.string().default('fullname'),
  sortDescending: z.coerce.boolean().default(false),
  archived: z.coerce.boolean().default(false),
  page: z.coerce.number().default(1),
  pageSize: z.coerce.number().default(20),
})

export const Route = createFileRoute('/helpdesk/customers/')({
  component: Customers,
  validateSearch: customersListSearchSchema,
})